'use client'

import { useStoreI18n } from '@/store'
import { StatusChip } from '@/ui/components'
import { memo } from 'react'

const Status = ({ status }: { status: 'OPEN' | 'CLOSED' }) => {
  const D = useStoreI18n.use.dictionary()

  return (
    <div className={'gap-2xs flex flex-col md:text-right'}>
      <p className="capitalize">{D['fe.lift.status']}</p>
      <div className={'inline-block max-md:mr-auto md:ml-auto'}>
        <StatusChip status={status === 'OPEN' ? 'success' : 'error'} />
      </div>
    </div>
  )
}

export default memo(Status)
